import React, { useEffect,useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import User from "./components/User";
import { MdDoubleArrow } from "react-icons/md";
import { WiTime2 } from "react-icons/wi";
import { useDispatch, useSelector } from "react-redux";
import { listSurveys, listLiveSurveys } from "../redux/slice/surveySlice";
import { use } from "react";

const PaidSurvey = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
 const [userId, setUserId] = useState(null);
 
  
  // Get profile surveys from assignedSurveys slice
  const assignedSurveys = useSelector((state) => state.assignedSurveys);
  const profileSurveysData = assignedSurveys?.surveys?.data || [];
  const liveSurveysData = assignedSurveys?.liveSurveys?.data || [];
  const isLoading = assignedSurveys?.surveyLoading || assignedSurveys?.liveSurveysLoading;

  // Get user data for UID replacement in live survey URLs
 
  useEffect(() => {
 
    const user = JSON.parse(localStorage.getItem("user"));
    // Try multiple possible paths for user ID
    const id = user?.id || "";
    setUserId(id);

 
  }, []);

  // Get user country from localStorage
  const getUserCountryCode = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.data?.countryCode || user?.countryCode || "";
  };

  useEffect(() => {
    dispatch(listSurveys());
    dispatch(listLiveSurveys());
  }, [dispatch]);

  // Transform and merge surveys
  const mergedSurveys = useMemo(() => {
    const userCountryCode = getUserCountryCode();
   

    // Transform profile surveys to unified format
    const profileSurveys = profileSurveysData.map((item) => ({
      id: item._id,
      type: "profile",
      name: item.title || item.name,
      loi: item.loi,
      status: item.status,
      reward: item.reward?.amount,
      currency: item.reward?.currency === "INR" ? "₹" : item.reward?.currency || "₹",
      endDate: item.endDate,
      startUrl: null,
    }));

    // Transform live surveys to unified format - filter by user's country
    const liveSurveys = liveSurveysData
      .map((item) => {
        // Find matching country from survey's countries array
        const matchingCountry = item.countries?.find(
          (c) => c.country?.toUpperCase() === userCountryCode?.toUpperCase()
        );

        // If no matching country found, return null (will be filtered out)
        if (!matchingCountry) return null;

        return {
          id: item._id,
          surveyId: item.surveyId,
          type: "live",
          name: item.basic?.name,
          loi: item.basic?.loi,
          status: item.status,
          reward: matchingCountry.vendorCpi,
          currency: matchingCountry.vendorCurrency === "INR" ? "₹" : matchingCountry.vendorCurrency || "₹",
          endDate: item.basic?.endDate,
          startUrl: matchingCountry.startUrl,
        };
      })
      .filter(Boolean); // Remove null entries (surveys without matching country)

    // Merge both arrays
    return [...profileSurveys, ...liveSurveys];
  }, [profileSurveysData, liveSurveysData]);

  console.log("Merged surveys data:", mergedSurveys);

  const openSurvey = (survey) => {
    if (survey.type === "live" && survey.startUrl) {
      // For live surveys, replace {{uid}} with userId and open the startUrl directly
      const finalUrl = survey.startUrl.replace("{{uid}}", userId || "");
      console.log("Opening live survey URL:", finalUrl, "userId:", userId);
      window.open(finalUrl, "_blank");
    } else {
      // For profile surveys, navigate to detail page
      navigate(`/survey/${survey.id}`);
    }
  };

  return (
    <div>
      <div className="container dashboard-page mt-4 min-h">
        <User />
        <div className="">
          <div className="site-card-wrapper">
            <h2 className="h3 mb-4">Surveys Assigned</h2>
            
            {isLoading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading surveys...</p>
              </div>
            ) : mergedSurveys.length === 0 ? (
              <div className="text-center py-4">
                <p>No surveys available at the moment.</p>
              </div>
            ) : (
              <div className="cards-container row row-cols-2 row-cols-sm-2 row-cols-md-4 row-cols-lg-3">
                {mergedSurveys.map((item, index) => (
                  <div className="col mb-4" key={`${item.type}-${item.id}-${index}`}>
                    <div
                      className="survey-card feedback-survey-card"
                      onClick={() => openSurvey(item)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="feedback-data">
                        
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="loi">
                            <WiTime2 /> {item.loi} min
                          </span>
                          <span className="loi">Status: {item.status}</span>
                        </div>
                        
                        <p>
                          Earn : {item.reward}
                        </p>
                        <p>Expire Date - {item.endDate?.split("T")[0]}</p>
                        
                        
                        
                        <span className="start-btn">
                          <MdDoubleArrow />
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaidSurvey;
